import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { Box, Card, Flex, Text } from '@resideo/blueprint-react';
import ResideoLogo from 'components/logos/resideo-knockout-logo-large.svg?react';
import NoticeLayoutFooter, { CustomBlocksType } from './NoticeLayoutFooter';
import { ADD_DISTRIBUTOR_OPTION_USER_TYPE } from '../../config/flags';

export interface NoticeLayoutRedesignProps {
  title?: string;
  showFooter?: boolean;
  defaultPadding?: boolean;
  mobileFooterPadding?: boolean;
  children?: ReactElement;
  customFooterBlocks?: CustomBlocksType;
}

export const BorderCard = styled(Card)`
  margin-bottom: ${({ theme }) => theme.space.small};
  border: 2px solid ${({ theme }) => theme.colors.background};
  max-width: 100%;
`;

const StyledResideoLogo = styled(ResideoLogo)`
  padding-top: ${({ theme }) => theme.space.large};
  margin-bottom: ${({ theme }) => theme.space.large};
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.large}) {
    padding-top: ${({ theme }) => theme.space.medium};
    margin-bottom: ${({ theme }) => theme.space.small};
  }
`;

const NoticeLayoutRedesign: FC<NoticeLayoutRedesignProps> = ({
  title,
  showFooter = true,
  defaultPadding = true,
  mobileFooterPadding = false,
  children,
  customFooterBlocks,
}): JSX.Element => {
  // Check for Shopify workflow from URL params
  const urlParams = new URLSearchParams(window.location.search);
  const isShopifyWorkflow = urlParams.get('userType') === 'distributor';

  // Use distributor feature width when both feature flag and Shopify workflow are true
  const shouldUseDistributorWidth =
    ADD_DISTRIBUTOR_OPTION_USER_TYPE && isShopifyWorkflow;
  const containerWidth = shouldUseDistributorWidth ? '725px' : '450px';
  return (
    <Flex
      flexDirection='column'
      alignItems='center'
      padding={defaultPadding ? ['small', 'xLarge'] : null}
      style={defaultPadding ? {} : { padding: '70px 0px 0px 0px' }}>
      <BorderCard borderRadius={['small', 'medium']}>
        <Flex
          flexDirection='column'
          alignItems='center'
          marginX={['small', 'xLarge', 'xxLarge']}
          width={['auto', 'auto', containerWidth]}>
          <StyledResideoLogo data-test-notice-layout-resideo-logo />
          <Flex marginBottom={['small', 'medium']}>
            <Text
              fontWeight='bold'
              fontSize='xLarge'
              lineHeight='2rem'
              data-test-notice-layout-header>
              {title}
            </Text>
          </Flex>
          {children}
        </Flex>
      </BorderCard>
      {showFooter && (
        <Box
          className='common-input'
          paddingBottom={mobileFooterPadding ? ['large', 0] : 0}>
          <NoticeLayoutFooter customFooterBlocks={customFooterBlocks} />
        </Box>
      )}
    </Flex>
  );
};

export default NoticeLayoutRedesign;
